import IOSSDK from '@/docs-partials/sdk/ios.mdx';
import * as React from 'react';
export default {
  IOSSDK,
  React
};